import { Component, OnInit, ElementRef, ViewChild, Renderer2, AfterViewInit, Output, EventEmitter } from '@angular/core';

// tslint:disable
@Component({
    selector: 'framework-loading',
    template: `
        <div #loadingBackdrop class="farris-loading-backdrop" *ngIf="isActive"></div>
        <div #loadingContainerEl class="framework-loading" *ngIf="isActive">
            <div class="load-music">
            <div class="loader loader-container-1"></div>
            <div class="loader loader-container-2"></div>
            <div class="loader loader-container-3"></div>
            <div class="loader loader-container-4"></div>
            <div class="loader loader-container-5"></div>
            </div>
        </div>
    `,
    styles: [
        `
        .load-music{
          position:relative;
          width:80px;
        }
    
        .load-music .loader {
          -webkit-animation: load-music 0.8s infinite ease-in-out;
          animation: load-music 0.8s infinite ease-in-out;
          width:5px;
          height: 32px;
          transform: translateZ(0);
          position: absolute;
          top: 0;
          left: 0;
          background-image: linear-gradient(107deg, #3F65FF 0%, #4D9AFF 100%);
          border-radius: 4px;
        }
        .load-music .loader-container-1 {
          -webkit-animation-delay: -0.15s;
          animation-delay: -0.15s;
    
        }
    
        .load-music .loader-container-2 {
          -webkit-animation-delay: -0.25s;
          animation-delay: -0.25s;
          left: 13px;
        }
    
        .load-music .loader-container-3 {
          -webkit-animation-delay: -0.35s;
          animation-delay: -0.35s;
          left: 26px;
          background-image: linear-gradient(-51deg, #56B0FF 0%, #328BFF 100%);
        }
    
        .load-music .loader-container-4 {
          -webkit-animation-delay: -0.45s;
          animation-delay: -0.45s;
          left: 39px;
          background-image: linear-gradient(95deg, #2A87FF 0%, #2A87FF 0%, #4CC3FF 100%);
        }
    
        .load-music .loader-container-5 {
          -webkit-animation-delay: -0.55s;
          animation-delay: -0.55s;
          background-image: linear-gradient(128deg, #2AAEFF 0%, #4CC3FF 100%);
          left: 52px;
        }
        .framework-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -64px;
          margin-left: -32px;
        }
    
        @keyframes load-music {
    
          0%,
          100% {
            top: 0;
            height: 28px;
          }
    
          40% {
            top: -18px;
            height: 64px;
          }
        }
        .farris-loading-backdrop {
            background-color: #ffffff;
            opacity: .0;
        }
        `
    ]
})
export class LoadingComponent implements OnInit, AfterViewInit {

    id: number;

    private _isActive = false;
    message = '正在加载，请稍候...';

    get isActive() {
        return this._isActive;
    }

    set isActive(val: boolean) {
        this._isActive = val;
        if (val) {
            this.animate('fadeIn');
        } else {
            this.el.nativeElement && this.el.nativeElement.remove();
        }

    }

    @ViewChild('loadingContainerEl') loadingContainerEl: ElementRef;
    @ViewChild('loadingBackdrop') loadingBackdrop: ElementRef;
    @Output() closed = new EventEmitter();


    constructor(private render: Renderer2, private el: ElementRef) { }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    ngAfterViewInit() {
        // setTimeout(() => this.setPosition(), 0 );
     //   this.setPosition();
    }

    close() {
        this.isActive = false;
    }

    private setPosition() {
        const containerWidth = this.loadingContainerEl.nativeElement.clientWidth;
        const containerHeight = this.loadingContainerEl.nativeElement.clientHeight;

        this.render.setStyle(this.loadingContainerEl.nativeElement, 'marginTop', -containerHeight / 2 + 'px');
        this.render.setStyle(this.loadingContainerEl.nativeElement, 'marginLeft', -containerWidth / 2 + 'px');
    }

    private animate(animateCls: string) {
        this.render.setAttribute(this.el.nativeElement, 'class', animateCls);
        this.addAnimationEndEvent('webkitAnimationEnd', 'mozAnimationEnd', 'MSAnimationEnd', 'oanimationend', 'animationend');
    }

    private addAnimationEndEvent(...events: string[]) {
        const _this = this;

        events.forEach(e => {
            _this.el.nativeElement.addEventListener(e, function handler() {
                _this.render.removeAttribute(_this.el.nativeElement, 'class');
                _this.el.nativeElement.removeEventListener(e, handler);

                _this.closed.emit(_this.isActive);
            });
        });
    }
}
